"use strict";

exports.__esModule = true;
exports.isUrl = void 0;
var isUrl = exports.isUrl = function isUrl(input) {
  try {
    new URL(input);
  } catch (_) {
    return false;
  }
  return true;
};